import { ButtonBase, Divider, Grow, Icon } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import MyModal from 'components/MyModal';
import Spin from 'components/Spin';
import { theme } from 'components/Theme';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { createProductCampaignTracker, deleteProductCampaignTracker, loadProductCampaignTracker, verifyDomain } from 'store/Orbita/Product/actions';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import Advanced from './components/Advanced';
import Basic from './components/Basic';
import Platforms, { enTypePlatform } from './components/Platforms';
import TagmanagerAlert from './components/TagmanagerAlert';
import styles from './styles';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  open: boolean;
  handleClose: any;
  product: any;
  campaign: any;
  classes?: any;
  loadTracker: any;
  loadDomain: any;
}

interface IStates {
  id: string;
  step: number;
  advanced: boolean;
  platformId: number;
  platformType: enTypePlatform;
  hasCampaign: boolean;
  hasPrice: boolean;
  hasBankslipPurchase: boolean;
  bankslipPurchase: string;
  domain?: string; // Facebook
  hasDomain: boolean; // Facebook
  tokenApi: string; // Facebook;
  pixel: string;
  registered: string[];
  isFetching: boolean;
  tracker: any;
  pages: string[];
  paymentMethods: {
    credit_card: number;
    bankslip: number;
    paypal: number;
    pix: number;
  };
  purchaseValue: string;
  sendCampaign: boolean;
  conversionLabel: string;
  validated: boolean;
}

class TrackerForm2 extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      id: '',
      step: 1,
      platformId: null,
      platformType: null,
      pages: ['checkout', 'thank_you_card', 'thank_you_bankslip', 'bankslip_view'],
      sendCampaign: true,
      advanced: false,
      domain: null,
      validated: false,
      pixel: '',
      registered: [],
      hasCampaign: true,
      hasPrice: true,
      hasBankslipPurchase: false,
      hasDomain: false,
      tokenApi: null,
      bankslipPurchase: 'send_purchase',
      isFetching: false,
      tracker: null,
      purchaseValue: 'send_purchase_value',
      conversionLabel: '',
      paymentMethods: {
        credit_card: 0,
        bankslip: 0,
        paypal: 0,
        pix: 0,
      },
    };
  }

  async componentDidMount() {
    await this.loadProductTracker();
  }

  loadProductTracker = async () => {
    try {
      this.setState({ isFetching: true });
      await this.props.dispatch(loadProductCampaignTracker(this.props.product.id));
      this.setState({
        isFetching: false,
        tracker: this.props.loadTracker,
      });
    } catch (error) {
      this.setState({ isFetching: false });
      toast.error(error);
    }

    const registered = this.props.loadTracker.pixel ? this.props.loadTracker.pixel.map((item: any): string[] => item.type) : [];
    const hasDomain = this.props.loadTracker.pixel ? this.props.loadTracker.pixel.find((item: any): boolean => item.type === 'facebook') : false;
    this.setState({ registered, hasDomain: !!hasDomain });
  };

  verifyDomain = async () => {
    const { pixel, domain } = this.state;
    const { product } = this.props;

    try {
      if (domain && pixel?.trim().length) {
        this.setState({ isFetching: true });
        await this.props.dispatch(verifyDomain(product.id));
        const { domain, validated } = this.props.loadDomain;
        this.setState({
          domain,
          validated,
          isFetching: false,
          hasDomain: !!domain,
        });
      }
    } catch (err) {
      toast.info('Pixel sem domínio cadastrado.');
      this.setState({
        isFetching: false,
      });
    }
  };

  handlePageChange = (name: keyof IStates) => () => {
    let pages = this.state.pages;
    let index = pages.findIndex((k) => k === name);
    index === -1 ? pages.push(name) : pages.length > 1 && pages.splice(index, 1);
    this.setState({ pages });
  };

  handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ purchaseValue: event.target.value });
  };

  handleAdvanced = () => {
    this.setState({ advanced: !this.state.advanced });
  };

  handleState = (tracker: Partial<IStates>) => {
    this.setState({ tracker });
  };

  handlePixel = (pixel: string) => {
    this.setState({ pixel });
  };

  handleDomain = (domain: string) => {
    this.setState({ domain: domain.replace(' ', '') });
  };

  handleTokenApi = (token: string) => {
    this.setState({ tokenApi: token.replace(' ', '') });
  };

  handleConversionLabel = (conversionLabel: string) => {
    this.setState({ conversionLabel });
  };

  handleBack = () => {
    this.setState({ step: 1, domain: '' });
  };

  handlePlatform = (
    platformId: number,
    platformType: enTypePlatform,
    hasCampaign: boolean,
    hasPrice: boolean,
    hasBankslipPurchase: boolean,
    step: number
  ) => {
    this.setState({ step, platformType, platformId, hasCampaign, hasBankslipPurchase, hasPrice });

    let platform = this.state.tracker.pixel && this.state.tracker.pixel.find((x: any) => x.type === platformType);

    if (platform) {
      platform.purchaseValue = 'never';

      if (platform.hasPurchaseValue) {
        platform.purchaseValue = 'send_purchase_value';
      }

      if (platform.hasCustomValues) {
        platform.purchaseValue = 'custom_values';
      }

      this.setState({
        id: this.state.tracker.id,
        pixel: platform.pixelId,
        pages: platform.enabledPages,
        paymentMethods: platform.forcePaymentValues,
        purchaseValue: platform.purchaseValue,
        bankslipPurchase: 'send_purchase',
        conversionLabel: platform.conversionLabel,
        tokenApi: platform.tokenApi,
        domain: platform.domain,
        validated: platform.validated,
      });
    } else {
      this.setState({
        id: '',
        pixel: '',
        conversionLabel: '',
        pages: ['checkout', 'thank_you_card', 'thank_you_bankslip', 'bankslip_view'],
        paymentMethods: {
          credit_card: 0,
          bankslip: 0,
          paypal: 0,
          pix: 0,
        },
        purchaseValue: 'send_purchase_value',
        bankslipPurchase: 'send_purchase',
      });
    }
  };

  checkCustomValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    let paymentMethods = this.state.paymentMethods;
    paymentMethods[event.target.value] > 0 ? (paymentMethods[event.target.value] = 0) : (paymentMethods[event.target.value] = 1);
    this.setState({ paymentMethods });
  };

  handleCustomValue = (value: any, number: any) => {
    let paymentMethods = this.state.paymentMethods;
    paymentMethods[value] = Number(number.replace(',', '.'));
    this.setState({ paymentMethods });
  };

  handleSendCampaign = () => {
    this.setState({ sendCampaign: !this.state.sendCampaign });
  };

  handleBankslipPurchase = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ bankslipPurchase: event.target.value });
  };

  handleDelete = async (idPixel: any, type: string) => {
    try {
      this.setState({ isFetching: true });

      await this.props.dispatch(deleteProductCampaignTracker(idPixel, type));
      await this.loadProductTracker();

      toast.success('Pixel removido com sucesso!');
      this.setState({ isFetching: false, step: 1, domain: '' });
    } catch (error) {
      toast.error(error);
    }
  };

  handleSubmit = async () => {
    let tracker: any = {
      type: this.state.platformType,
      pixelId: this.state.pixel,
      domain: this.state.domain,
      enabledPages: this.state.pages,
      forcePaymentValues: this.state.paymentMethods,
      tokenApi: this.state.tokenApi,
      contentId: this.props.product.id,
      hasCampaign: this.state.sendCampaign,
      hasPurchaseValue: true,
      conversionLabel: this.state.conversionLabel,
      bankslipPurchase: this.state.bankslipPurchase,
      validated: this.state.validated,
    };

    if (this.state.purchaseValue === 'custom_values') {
      tracker.hasCustomValues = true;
    }

    if (this.state.purchaseValue === 'send_purchase_value') {
      tracker.hasCustomValues = false;
    }

    if (this.state.purchaseValue === 'never') {
      tracker.hasPurchaseValue = false;
    }

    try {
      this.setState({ isFetching: true });

      await this.props.dispatch(createProductCampaignTracker(tracker, this.state.id));
      this.setState({ domain: '', validated: false });
      await this.loadProductTracker();
      toast.success('Pixel cadastrado com sucesso!');
      this.setState({ isFetching: false, step: 1 });
    } catch (error) {
      toast.error('Erro ao salvar o pixel');
      this.setState({ isFetching: false });
    }
  };

  render() {
    const { classes } = this.props;
    const { registered, domain, validated, hasDomain, tokenApi } = this.state;

    const isBetaG4 = eduzzAccountsService.verifyUserHasBetaModule('pixel_google_G4');
    const isBetaTikTok = eduzzAccountsService.verifyUserHasBetaModule('pixel_tiktok');
    const userEnabledPixels = Platforms.filter((item) => {
      if (item.type === enTypePlatform.GOOGLE_ANALYTICSG4) {
        return isBetaG4;
      }

      if (item.type === enTypePlatform.TIKTOK) {
        return isBetaTikTok;
      }

      return true;
    });

    return (
      <MuiThemeProvider theme={theme}>
        <MyModal
          hasActive={this.props.open}
          closeModal={this.props.handleClose}
          hasButtons
          loading={this.state.isFetching}
          hideButtonOk={this.state.step !== 2}
          title='Pixel de Rastreamento'
          subTitle='Selecione a plataforma que deseja cadastrar o pixel:'
          textButtonOk='Salvar'
          textButtonCancel='Fechar'
          style={{ transition: 'all 0.3s' }}
          handleClickOk={this.handleSubmit}
        >
          <div className='m8' />
          {this.state.step === 1 && (
            <Fragment>
              {this.state.isFetching ? (
                <Spin />
              ) : (
                <div className={classes.buttonGroup}>
                  {userEnabledPixels.map((item, index) => (
                    <Grow key={`grow-${index}`} in={!this.state.isFetching} timeout={(index + 1) * 500}>
                      <ButtonBase
                        key={`platform-${index}`}
                        className={`${classes.buttonbase} ` + (registered.includes(item.type) ? 'registered' : '')}
                        onClick={() => this.handlePlatform(item.id, item.type, item.hasCampaign, item.hasPrice, item.hasBankslipPurchase, 2)}
                      >
                        <img src={item.image} alt={item.label} className={classes.brandImg} />
                      </ButtonBase>
                    </Grow>
                  ))}
                </div>
              )}
            </Fragment>
          )}
          {this.state.step === 2 && (
            <Grow in={true} timeout={1000}>
              <div style={{ marginRight: 16 }}>
                <TagmanagerAlert type={this.state.platformType} pixels={this.state.tracker.pixel || []} />
                <Basic
                  platformType={this.state.platformType}
                  conversionLabel={this.state.conversionLabel}
                  loading={this.state.isFetching}
                  pixel={this.state.pixel}
                  hasDomain={hasDomain}
                  domain={domain}
                  tokenApi={tokenApi}
                  validated={validated}
                  pixelId={this.state.id}
                  handleTokenApi={this.handleTokenApi}
                  back={this.handleBack}
                  handleConversionLabel={this.handleConversionLabel}
                  handleReload={this.verifyDomain}
                  handlePixel={this.handlePixel}
                  handleDelete={this.handleDelete}
                  handleDomain={this.handleDomain}
                />
                <ButtonBase className={classes.expand} onClick={this.handleAdvanced}>
                  {'Configurações adicionais  '}
                  {this.state.advanced ? <Icon fontSize='inherit'>expand_less</Icon> : <Icon fontSize='inherit'>expand_more</Icon>}
                </ButtonBase>
                <div className='m24' />
                <Divider />
                <Advanced
                  handlePageChange={this.handlePageChange}
                  handleSendCampaign={this.handleSendCampaign}
                  handleRadioChange={this.handleRadioChange}
                  handleCustomValue={this.handleCustomValue}
                  handleBankslipPurchase={this.handleBankslipPurchase}
                  checkCustomValue={this.checkCustomValue}
                  state={this.state}
                />
              </div>
            </Grow>
          )}
        </MyModal>
      </MuiThemeProvider>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    loadTracker: state.orbita.Product.loadProductCampaignTracker,
    loadDomain: state.orbita.Product.verifyDomain,
  };
}

export default connect(mapStateToProps)(styles(TrackerForm2));
